module.exports = __webpack_public_path__ + "img/on_store_download.af078ca8.png";